import { fetchCityList, fetchAllSurveyList } from "./cityProfileUtils";

// Scoped to the CityProfile/CityComparison page only — does not touch
// cityProfileUtils.js, so every other caller of fetchCityList/fetchAllSurveyList
// (Charts.js, BasicDataInsertion.jsx, MapDataInsertion.jsx) is unaffected.
const CACHE_TTL_MS = 5 * 60 * 1000;

function createCachedFetcher(fetchFn) {
  let cachedData = null;
  let cachedAt = 0;
  let inflightPromise = null;

  return async (request, setter) => {
    const isFresh = cachedData !== null && Date.now() - cachedAt < CACHE_TTL_MS;
    if (isFresh) {
      setter && setter(cachedData);
      return cachedData;
    }

    if (!inflightPromise) {
      inflightPromise = fetchFn(request, (data) => {
        cachedData = data;
        cachedAt = Date.now();
      }).finally(() => {
        inflightPromise = null;
      });
    }

    await inflightPromise;
    if (cachedData !== null) {
      setter && setter(cachedData);
    }
    return cachedData;
  };
}

export const fetchCityListCached = createCachedFetcher(fetchCityList);
export const fetchAllSurveyListCached = createCachedFetcher(fetchAllSurveyList);
